<p-autoComplete
		[autoHighlight]="true"
		[delay]="500"
		field="item.name"
		placeholder="Search Customer"
		[minLength]="1"
		[suggestions]="dropDownItems"
		[size]="30"
		[forceSelection]="true"
		(onSelect)="updateCustomer($event)"
		(onClear)="deleteCustomer($event)"
		(completeMethod)="filterCountrySingle($event)"
		[(ngModel)]="currentChoise"
		[ngModelOptions]="{standalone: true}"
		#customerCompleteInput>
	<ng-template let-choise pTemplate="item">
		<span *ngIf="choise.type === 'item'">{{choise.item.name}} <span *ngIf="choise.item.qbId" class="qb-logo">QB</span></span>
		<span *ngIf="choise.type === 'create-new'" class="new-customer" (click)="newCustomer(customerCompleteInput)">
			Create Customer
		</span>
	</ng-template>
</p-autoComplete>

<div class="edit-icon" *ngIf="customer">
	<mat-icon (click)="openClientWindow()">open_in_new</mat-icon>
</div>